module.exports = __webpack_public_path__ + "img/187117.4a884ba5.svg";